module.exports = __webpack_public_path__ + "img/top_banner.704cff84.png";